import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-752f4f5a")

_pushScopeId("data-v-752f4f5a")
const _hoisted_1 = {
  class: "absolute right-0 m-5 top-22 show snackbar",
  id: ""
}
const _hoisted_2 = { class: "flex items-center px-3 py-2 mb-2 bg-red-500 border-l-4 border-red-700 shadow-md" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "mr-3 text-red-500 bg-white rounded-full" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "1.8em",
    height: "1.8em",
    viewBox: "0 0 16 16",
    class: "bi bi-x",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      d: "M11.854 4.146a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708-.708l7-7a.5.5 0 0 1 .708 0z"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      d: "M4.146 4.146a.5.5 0 0 0 0 .708l7 7a.5.5 0 0 0 .708-.708l-7-7a.5.5 0 0 0-.708 0z"
    })
  ])
], -1)
const _hoisted_4 = {
  class: "max-w-xs text-white",
  "data-testid": "error-message"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("div", _hoisted_4, _toDisplayString(_ctx.message), 1)
    ])
  ]))
})